module.exports = __webpack_public_path__ + "static/header-image-08-f390f74cf1d95aeed06d1439f96a1471.png";